import type { QuickFilterOption } from "@/shared/components";

// Default quick filter options for date range selection
export const DEFAULT_QUICK_FILTERS: QuickFilterOption[] = [
  { amount: 1, unit: "hour", label: "Last Hour" },
  { amount: 24, unit: "hour", label: "Last Day" },
  { amount: 7, unit: "day", label: "Last Week" },
  { amount: 1, unit: "month", label: "Last Month" },
  { amount: null, unit: "day", label: "All Time" }, // unit is ignored when amount is null
];

// Default quick filter for initial load
export const DEFAULT_QUICK_FILTER: QuickFilterOption = {
  amount: 24,
  unit: "hour",
  label: "Last Day",
};
